export class LoginPasswordForm {
    $passwordField = $('#Password');
    $cguAcceptanceRequiredField = $('#CguAcceptanceRequired');
    $rgpdAcceptanceRequiredField = $('#RgpdAcceptanceRequired');
    $CguAcceptedField = $('#CguAccepted');
    $RgpdAcceptedField = $('#RgpdAccepted');
    $btnConnect = $('#btn-connect');

    // CGU
    $closeCguBtn = $('#btn-close-cgu');
    $termsAndConditionsModal = $('#terms-and-conditions-modal');

    init() {
        this.$CguAcceptedField.on('change', () => this.disablingConnectButton());
        this.$RgpdAcceptedField.on('change', () => this.disablingConnectButton());
        this.$passwordField.on('input', () => this.disablingConnectButton());
        this.disablingConnectButton();


        this.$closeCguBtn.on('click', (e) => {
            e.preventDefault();
            this.$termsAndConditionsModal.modal('hide');
        });
    }

    disablingConnectButton(){
        if (!this.canSubmit()) {
            this.$btnConnect.attr('disabled', 'disabled');
        } else {
            this.$btnConnect.removeAttr('disabled');
        }
    }

    canSubmit(){
        if(this.$passwordField.val().toString().length===0)
        {
            return false;
        }

        if (this.$cguAcceptanceRequiredField.val() === 'true' && !this.$CguAcceptedField.is(':checked'))
        {
            return false;
        }

        if(this.$rgpdAcceptanceRequiredField.val() === 'true' && !this.$RgpdAcceptedField.is(':checked'))
        {
            return false;
        }

        return true;
    }
}